var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-info",
    clipPath: "url(#clip0_255212_994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 16.427C9.58225 16.427 11.129 15.9578 12.4446 15.0788C13.7602 14.1997 14.7855 12.9503 15.391 11.4885C15.9965 10.0267 16.155 8.41813 15.8463 6.86628C15.5376 5.31444 14.7757 3.88897 13.6569 2.77015C12.538 1.65133 11.1126 0.889405 9.56072 0.580723C8.00887 0.272042 6.40034 0.430468 4.93853 1.03597C3.47672 1.64147 2.22729 2.66685 1.34824 3.98244C0.469192 5.29804 0 6.84476 0 8.42701C0.00229405 10.548 0.845886 12.5815 2.34568 14.0813C3.84547 15.5811 5.87897 16.4247 8 16.427ZM8 3.76034C8.19778 3.76034 8.39112 3.81899 8.55557 3.92887C8.72002 4.03875 8.84819 4.19493 8.92388 4.37766C8.99957 4.56038 9.01937 4.76145 8.98079 4.95543C8.9422 5.14941 8.84696 5.32759 8.70711 5.46745C8.56726 5.6073 8.38907 5.70254 8.19509 5.74112C8.00111 5.77971 7.80004 5.75991 7.61732 5.68422C7.43459 5.60853 7.27841 5.48036 7.16853 5.31591C7.05865 5.15146 7 4.95812 7 4.76034C7 4.49512 7.10536 4.24077 7.29289 4.05323C7.48043 3.8657 7.73478 3.76034 8 3.76034ZM7.33333 7.09367H8C8.35362 7.09367 8.69276 7.23415 8.94281 7.4842C9.19286 7.73425 9.33333 8.07338 9.33333 8.42701V12.427C9.33333 12.6038 9.2631 12.7734 9.13807 12.8984C9.01305 13.0234 8.84348 13.0937 8.66667 13.0937C8.48986 13.0937 8.32029 13.0234 8.19526 12.8984C8.07024 12.7734 8 12.6038 8 12.427V8.42701H7.33333C7.15652 8.42701 6.98695 8.35677 6.86193 8.23174C6.73691 8.10672 6.66667 7.93715 6.66667 7.76034C6.66667 7.58353 6.73691 7.41396 6.86193 7.28893C6.98695 7.16391 7.15652 7.09367 7.33333 7.09367Z",
    fill: "#769227"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255212_994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.427002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b46b1ac344fba2525651612f36abc5df.svg";
export { ForwardRef as ReactComponent };